export const studyInfoLookup = () => {
    return {
        p1ScientificTitle: {
            number: '1.1',
            label: 'Scientific Title',
            isTextArea: true,
        },
        p1ShortTitle: {
            number: '1.1.1',
            label: 'Short Title',
            isTextArea: true,
        },
        p1KeyWords: {
            number: '1.1.2',
            label: 'Key Words',
            isTextArea: true,
        },
        p1ResProNum: {
            number: '1.2',
            label: 'Research protocol number',
        },
        p1LocalInternational: {
            number: '2.1',
            label: 'Is this a local or international trial?',
        },
        p1ConductedHa: {
            number: '2.2',
            label: 'Will the study be conducted in HA hospitals/institutions',
        },
        studySiteCollab: {
            number: '2.3.2',
            label: 'Collaborating site(s) in HA',
        },
        p1ConductedOutOfHa: {
            number: '2.3.3',
            label: 'Will the study be conducted out-of-HA',
        },
        studySiteOutOfHA: {
            number: '2.3.3',
            label: 'Will the study be conducted out-of-HA?',
        },
        p1ReviewByRecIrb: {
            number: '3.1',
            label: 'Has the application been reviewed by another Cluster REC/IRB?',
        },
        p1RecIrbDecision: {
            number: '3.1.1',
            label: 'What is REC/IRB decision?',
        },
        p1ProposedStartDate: {
            number: '4.1',
            label: 'Proposed study start date',
        },
        p1ProposedEndDate: {
            number: '4.2',
            label: 'Proposed study end date / date of last follow-up of all recruited subjects, whichever is later',
        },
        p1SubmissionDate: {
            number: '4.3',
            label: 'Tentative final report submission date to CIRB/CREC/IRB',
        },
        p1BriefSummary: {
            number: '5',
            label: 'Brief Summary of Study',
            isTextArea: true,
        },
        p2Aim: {
            number: '6.1',
            label: 'Aim of study',
            isTextArea: true,
        },
        p2Hypothesis: {
            number: '6.2',
            label: 'Hypothesis',
            isTextArea: true,
        },
        p2PrimaryOutcome: {
            number: '6.3.1',
            label: 'Primary outcome(s)',
            isTextArea: true,
        },
        p2SecondaryOutcome: {
            number: '6.3.2',
            label: 'Secondary outcome(s)',
            isTextArea: true,
        },
        p2Inclusion: {
            number: '7.1',
            label: 'Inclusion criteria',
            isTextArea: true,
        },
        p2Exclusion: {
            number: '7.2',
            label: 'Exclusion criteria',
            isTextArea: true,
        },
        p2Sample: {
            number: '7.3.1',
            label: 'Sample size',
        },
        p2Rationale: {
            number: '7.3.2',
            label: 'Based on the following rationale',
            isTextArea: true,
        },
        p2HAPatients: {
            number: '7.3.3',
            label: 'Will the study involve HA patients?',
        },
        p2NumPatients: {
            number: '7.3.3.1',
            label: 'If yes, estimate the number of patients planned to be involved in the study?',
        },
        p2RoleHA: {
            number: '7.3.3.2',
            label: 'If no, specify the role of HA in the study',
            isTextArea: true,
        },
        p2NumSubject: {
            number: '7.4',
            label: 'Number of subjects to be recruited locally in applying site(s)',
        },
        p2SubjectRecruit: {
            number: '7.5',
            label: 'How will subject be identified and recruited',
            isTextArea: true,
        },
        p2StudyDesign: {
            number: '8.1',
            label: 'Study design',
        },
        p2StudyNature: {
            number: '8.2',
            label: 'Study design (Nature)',
        },
        p2Other: {
            number: '8.2.1',
            label: 'If Other, specify',
        },
        p2Control: {
            number: '8.3',
            label: 'Control',
        },
        p2GroupAssignment: {
            number: '8.4',
            label: 'Group assignment',
        },
        p2DiseaseGroup: {
            number: '8.5',
            label: 'Disease group (choose the most appropriate one)',
        },
        p2KeyConditions: {
            number: '8.5.1',
            label: 'Key conditions under study',
        },
        p2MethodsOfAnalysis: {
            number: '9',
            label: 'Methods of Data Analysis',
            isTextArea: true,
        },
        p2PersonalStore: {
            number: '10.1',
            label: 'Will personal data be stored during and after the study?',
        },
        p2PersonalHandle: {
            number: '10.2',
            label: 'How will the personal and study data be handled and stored during and after the study?',
            isTextArea: true,
        },
        p2PersonalAccess: {
            number: '10.3',
            label: 'Who will have access to the personal and study data during and after the study?',
            isTextArea: true,
        },
        p2PersonalResponse: {
            number: '10.4',
            label: 'Who will be responsible for safekeeping of the personal and study data during and after the study?',
            isTextArea: true,
        },
        p2DataKeep: {
            number: '10.5',
            label: 'How many years will the personal and study data be kept after the study?',
        },
        p2DataAforesaidPeriod: {
            number: '10.6',
            label: 'Plan arrangement for the personal and study data after completion of the aforesaid storage period?',
            isTextArea: true,
        },
        p2Procedure: {
            number: '11.1',
            label: 'How does the procedure/treatment differ from current treatment practice?',
        },
        p2ProcedureOther: {
            number: '11.1.1',
            label: 'If others, specify',
        },
        p2MethodAssignment: {
            number: '11.1.2',
            label: 'Methods of assignment',
        },
        p2DegreeMasking: {
            number: '11.1.3',
            label: 'Degree of masking',
        },
        p2PhaseStudy: {
            number: '11.1.4',
            label: 'Phase 1 Panels are available in HKU/HKW IRB and the Joint CUHK-NTEC CREC.',
        },
        p2StudyArticle: {
            number: '11.2.1',
            label: 'Is there any study article?',
        },
        studyArticleDetail: {
            number: '11.2.2',
            label: 'Study article details',
        },
        StudyArticleLicense: {
            number: '11.2.3',
            label: 'Study article licence registration',
        },
        p2CertificateCTC: {
            number: '11.2.4',
            label: 'Will a Certificate for Clinical Trial (“CTC”) be obtained for the Study? ',
        },
        p2Justification: {
            number: '11.2.4.1',
            label: 'If no, justification',
            isTextArea: true,
        },
        p2NumOfExtra: {
            number: '11.3',
            label: 'Number of extra visits / admission on top of usual care',
        },
        p2OtherInvestigator: {
            number: '11.4',
            label: 'Will any of the study interventions / procedures be performed by persons other than the investigators?',
        },
        p2WhomWhere: {
            number: '11.4.1',
            label: 'If yes, by whom and where',
        },
        p2SampleFurtherUse: {
            number: '11.5',
            label: 'Will biological samples be stored for future use?',
        },
        p2SamplePurpose: {
            number: '11.5.1',
            label: 'What is the purpose to store the sample?',
            isTextArea: true,
        },
        p2SampleNature: {
            number: '11.5.2',
            label: 'State the nature of the sample',
            isTextArea: true,
        },
        p2SampleAnticipate: {
            number: '11.5.3',
            label: 'Anticipate duration of storage',
        },
        p2SampleOutsideHK: {
            number: '11.5.4',
            label: 'Will the samples be sent / stored outside Hong Kong?',
        },
        p2SampleConsent: {
            number: '11.5.5',
            label: 'Will consent for future specified usage of the biological samples be obtained from the subject?',
        },
        p2SampleObtained: {
            number: '11.5.5.1',
            label: 'When will the consent be obtained?',
        },
        p2SampleJustification: {
            number: '11.5.5.2',
            label: 'Justification for consent to be obtained prior to the specific future usage of the sample',
            isTextArea: true,
        },
        p2SampleStated: {
            number: '11.5.5.3',
            label: 'Where will the consent be stated?',
        },
        p2NoConsentJustification: {
            number: '11.5.5.4',
            label: 'Justification for no consent to be obtained',
            isTextArea: true,
        },
        p2Significant: {
            number: '12.1',
            label: 'Significant difference(s) from usual management',
            isTextArea: true,
        },
        p2Benefits: {
            number: '12.2',
            label: 'Anticipated benefits to study subjects',
            isTextArea: true,
        },
        p2ProvidedCard: {
            number: '12.3',
            label: 'Will the subjects be provided with a card indicating their participation in study and means of urgent contact?',
        },
        p2HowToIdentified: {
            number: '12.3.1',
            label: 'If no, state how the research subjects can be identified in case of emergency',
            isTextArea: true,
        },
        p2ICHGCP: {
            number: '12.4',
            label: 'Does the protocol state compliance with the ICH-GCP?',
        },
        p2ICHGCPJustification: {
            number: '12.4.1',
            label: 'If no, justification',
            isTextArea: true,
        },
        p3Methodology: {
            number: '13.1',
            label: 'Methodology of obtaining consent',
        },
        p3MethodReasons: {
            number: '13.1.1',
            label: 'State reasons if not use written consent',
            isTextArea: true,
        },
        p3MethodJustification: {
            number: '13.1.2',
            label: 'Justification for applying to waive the consent requirement (<1,000 characters)',
            isTextArea: true,
        },
        p3InformConsentPrincipalInv: {
            number: '13.2',
            label: 'Who will carry out the informed consent process with the subject?',
        },
        p3InformConsentOthersReason: {
            number: '13.2',
            label: 'Other description',
        },
        p3Interpreter: {
            number: '13.3',
            label: 'Will an interpreter be available when required?',
        },
        p3InterpreterJustification: {
            number: '13.3.1',
            label: 'If no, justification',
        },
        p3MinTime: {
            number: '13.4',
            label: 'In obtaining informed consent from subjects, what is the minimal time given to a subject to consider after explanation has been given?',
        },
        p3Arrangement: {
            number: '13.5',
            label: 'If subjects are incompetent in giving consent, what would be the arrangement?',
            isTextArea: true,
        },
        p3IndepCommittee: {
            number: '14.1',
            label: 'Will an independent committee review data and safety of study?',
        },
        p3IndepCommitteeJustification: {
            number: '14.1.1',
            label: 'If no, justification',
            isTextArea: true,
        },
        p3Ethical: {
            number: '15',
            label: 'Major Ethical Issues',
            isTextArea: true,
        },
        p3PreferenceFull: {
            number: '16.1',
            label: `Applicant's Preference`,
        },
        p3Justification: {
            number: '16.2',
            label: 'Justification',
            isTextArea: true,
        },
        p3ExtraClinical: {
            number: '17.1',
            label: 'Will study incur extra clinical intervention(s) to subjects?',
        },
        p3AdditionalRisk: {
            number: '17.2',
            label: 'Will study impose additional risk to subjects?',
        },
        checkAtLeastOne: {
            number: '17.2.1',
            label: 'If yes, please select the following where applicable and provide details',
        },
        p3AddRiskPhyReason: {
            number: '17.2.1',
            label: 'Reason of physical',
            isTextArea: true,
        },
        p3AddRiskPsyReason: {
            number: '17.2.1',
            label: 'Reason of psychological',
            isTextArea: true,
        },
        p3AddRiskRadReason: {
            number: '17.2.1',
            label: 'Reason of radiation',
            isTextArea: true,
        },
        p3AddRiskOtherReason: {
            number: '17.2.1',
            label: 'Reason of others',
            isTextArea: true,
        },
        p3Privacy: {
            number: '17.3',
            label: 'Will study raise privacy concerns?',
        },
        p3InvolveChildren: {
            number: '17.4.1',
            label: 'Children or adolescent (of less than 18-year-old)',
        },
        p3InvolveIlliterates: {
            number: '17.4.2',
            label: 'Illiterates',
        },
        p3InvolveIncapacitated: {
            number: '17.4.3',
            label: 'Mentally incapacitated persons',
        },
        p3InvolveImpoverished: {
            number: '17.4.4',
            label: 'Impoverished persons',
        },
        p3InvolveEthnic: {
            number: '17.4.5',
            label: 'Ethnic minority groups',
        },
        p3InvolvePatients: {
            number: '17.4.6',
            label: 'Patients in emergency conditions',
        },
        p3InvolvePrisoners: {
            number: '17.4.7',
            label: 'Prisoners',
        },
        p3InvolveSubordinates: {
            number: '17.4.8',
            label: 'Subordinates or students of investigators',
        },
        p3InvolveOthers: {
            number: '17.4.9',
            label: 'Others',
        },
        p3InvolveOtherSpecify: {
            number: '17.4.9.1',
            label: 'Specify',
        },
        p3SpecialPrecaution: {
            number: '17.5',
            label: 'Are there any special precautions to protect the interest of vulnerable subjects?',
            isTextArea: true,
        },
        p3Hazard: {
            number: '17.6',
            label: 'Will study impose potential hazard to clinical staff?',
        },
        p3Control: {
            number: '17.6.1',
            label: 'Control measures to protect the clinical staff',
            isTextArea: true,
        },
        p4Funding: {
            number: '18.1',
            label: 'Any source of funding?',
        },
        funding: {
            number: '18.1.1',
            label: 'Specify the source of funding',
            isTextArea: true,
        },
        p4NonMonetary: {
            number: '18.2',
            label: 'Any non-monetary support?',
        },
        support: {
            number: '18.2.1',
            label: 'Specify the non-monetary support',
        },
        p4SupportArrange: {
            number: '18.2.2',
            label: 'Please provide details arrangements of the non-monetary support',
            isTextArea: true,
        },
        p4Sponsor: {
            number: '18.3',
            label: 'Is it a sponsored study?',
        },
        p4SponsorType: {
            number: '18.3.1',
            label: 'Which type of sponsored study?',
        },
        p4ExtraHAResources: {
            number: '19.1',
            label: 'Will this study consume extra HA resources?',
        },
        p4ExtraHAResourcesDetails: {
            number: '19.1.1',
            label: 'If yes, provide details',
            isTextArea: true,
        },
        p4ExtraHAResourcesAffect: {
            number: '19.1.2',
            label: 'If extra HA resources is required, how will this affect the HA services of other patients with competing needs?',
            isTextArea: true,
        },
        p4ReimburseFormat: {
            number: '19.2.1',
            label: 'If yes, state the format of reimbursement',
            isTextArea: true,
        },
        p4ReimburseReason: {
            number: '19.2.2',
            label: 'If no, state the reason(s)',
            isTextArea: true,
        },
        p4Charged: {
            number: '20.1',
            label: 'Will the subjects be charged for the study article/service?',
        },
        p4FinArrangement: {
            number: '20.1.1',
            label: 'If yes, state the financial arrangement',
            isTextArea: true,
        },
        p4ConAvailable: {
            number: '20.2',
            label: 'Will the study article continue to be available to subjects after the study (if subjects benefited from it) until it is commercially available?',
        },
        p4PlanFinArrangement: {
            number: '20.2.1',
            label: 'If yes, state the planned financial arrangement',
        },
        p4ImpactDisease: {
            number: '20.2.2',
            label: 'If no, will there be any impact on disease management of the study subject?',
            isTextArea: true,
        },
        p4DiseaseArrangement: {
            number: '20.2.2.1',
            label: 'Provide arrangement',
            isTextArea: true,
        },
        p4Explain: {
            number: '20.3',
            label: 'Does the consent form explain the above arrangement?',
        },
        p4Rewards: {
            number: '20.4',
            label: 'Will subjects receive any material rewards (including payments)?',
        },
        p4RewardsNature: {
            number: '20.4.1',
            label: 'Reward nature',
        },
        p4RewardsOther: {
            number: '20.4.1',
            label: 'Others',
            isTextArea: true,
        },
        p4RewardsAmount: {
            number: '20.4.2',
            label: 'Amount of payment (in HK$)',
        },
        p4RewardsMode: {
            number: '20.4.3',
            label: 'Mode of payment',
        },
        p4RewardsSchedule: {
            number: '20.4.3',
            label: 'Schedule',
        },
        p4Responsible: {
            number: '21.1',
            label: 'The organization / individual responsible for the study',
        },
        collaborating: {
            number: '21.2',
            label: 'Collaborating parties that jointly take on the responsibilities for the study',
        },
        p4Indemnify: {
            number: '21.3.1',
            label: 'For sponsored clinical research or where commercial interest is involved, will the sponsor indemnify study related claims?',
        },
        p4IndemnifyResponsible: {
            number: '21.3.1.1',
            label: 'If no, specify the reason and who will be responsible for the indemnity',
        },
        p4IndemnifyBaseOnHA: {
            number: '21.3.1.2',
            label: 'Is the indemnity agreement based on the HA approved form?',
        },
        p4Insurance: {
            number: '21.4',
            label: 'Will an insurance policy be arranged for the study?',
        },
        p4AgreementSigned: {
            number: '21.5',
            label: 'Will a Clinical Trial Agreement or other legal agreement/contract(s) be signed with the sponsor/supporting party?',
        },
        /** document upload start */
        docUpload_0: {
            number: '22',
            label: 'Research Protocol (Mandatory)',
        },
        docUpload_1: {
            number: '23',
            label: 'Subject Information Sheet and Informed Consent Form (Supplementary)',
        },
        docUpload_2: {
            number: '24',
            label: "Investigator's Brochure (Supplementary)",
        },
        docUpload_3: {
            number: '25',
            label: 'Written information for subject, such as recruitment advertisement, etc (Supplementary)',
        },
        docUpload_4: {
            number: '26',
            label: 'Questionnaires (Supplementary)',
        },
        docUpload_5: {
            number: '27',
            label: 'Conflict of Interest Declaration by all Investigators (Mandatory) (*To Complete in Site info)',
        },
        docUpload_6: {
            number: '28',
            label: 'Indemnity Agreement (Mandatory for sponsored trial) (*To Complete in Site info)',
        },
        docUpload_cti: {
            number: '29',
            label: 'Clinical Trial Insurance Certificate (Mandatory for sponsored trial)',
        },
        docUpload_11: {
            number: '30',
            label: 'Other Documents – Study based (Supplementary)',
        },
        docUpload_7: {
            number: '31',
            label: 'Supporting document from Academia (Mandatory for student project)',
        },
        docUpload_8: {
            number: '32',
            label: 'CIRB/CREC/IRB decision document of clinical research ethics review for cross-cluster study (Mandatory if applicable)',
        },
        docUpload_9: {
            number: '33',
            label: 'Other funding source(s) (Supplementary)',
        },
        docUpload_10: {
            number: '34',
            label: 'Signed Application Form – Declaration and Endorsement (Mandatory) (*To Complete in Site info)',
        },

        /** document upload end */
    };
};

export const siteInfoLookup = () => {
    return {
        title: {
            number: '1',
            label: 'Title (e.g. Mr, Mrs, Ms, Miss, Dr)',
        },
        surname: {
            number: '1',
            label: 'Surname',
        },
        firstName: {
            number: '1',
            label: 'First Name',
        },
        chineseName: {
            number: '1',
            label: 'Name in Chinese',
        },
        atLeastOneSelected: {
            number: '2',
            label: 'At one position should be selected',
        },
        haStaff: {
            number: '2.1',
            label: 'HA Staff (Including HA Honorary staff)',
        },
        haPosition: {
            number: '2.1.1',
            label: 'Position',
        },
        haDepartment: {
            number: '2.1.2',
            label: 'Department / Unit',
        },
        haClusterCode: {
            number: '2.1.3',
            label: 'Cluster',
        },
        haHospitalCode: {
            number: '2.1.4',
            label: 'Hospital',
        },
        haOther: {
            number: '2.1.4.1',
            label: 'If Other, specify',
        },
        uniStaff: {
            number: '2.2',
            label: 'University Staff',
        },
        uniPosition: {
            number: '2.2.1',
            label: 'Position',
        },
        uniDepartment: {
            number: '2.2.2',
            label: 'Department / School / Faculty',
        },
        university: {
            number: '2.2.3',
            label: 'University',
        },
        uniOther: {
            number: '2.2.3.1',
            label: 'If Other, specify',
        },
        student: {
            number: '2.3',
            label: 'Student',
        },
        studentFull: {
            number: '2.3.1',
            label: 'Full-time / Part-time',
        },
        studentGraduate: {
            number: '2.3.1.1',
            label: 'Undergraduate / Post-graduate',
        },
        studentDept: {
            number: '2.3.1.2',
            label: 'Department / School / Faculty',
        },
        studentInst: {
            number: '2.3.1.3',
            label: 'Institute',
        },
        supervisorName: {
            number: '2.3.2',
            label: 'Name of Academic Supervisor',
        },
        supervisorDept: {
            number: '2.3.2.1',
            label: 'Department / School / Faculty',
        },
        supervisorInst: {
            number: '2.3.2.2',
            label: 'Institute',
        },
        siteSupervisorName: {
            number: '2.3.3',
            label: 'Name of Site supervisor',
        },
        siteSupervisorDept: {
            number: '2.3.3.1',
            label: 'Department / Unit',
        },
        siteSupervisorHospCode: {
            number: '2.3.3.2',
            label: 'Hospital',
        },
        siteSupervisorOther: {
            number: '2.3.3.2.1',
            label: 'If Other, specify',
        },
        phone: {
            number: '2.4',
            label: 'Phone Number',
        },
        email: {
            number: '2.5',
            label: 'E-mail address',
        },
        mailing: {
            number: '2.6',
            label: 'Mailing address',
        },
        cvFileName: {
            number: '2.7',
            label: 'CV File Upload',
        },
        coiInvolved: {
            number: '3',
            label: 'Any Co-investigators Involved in this study?',
        },
        coi: {
            number: '3',
            label: 'Co-investigators Members',
        },
        studySiteApply: {
            number: '2.3.1',
            label: 'Applying site(s) in HA',
        },
        p2NumSubject: {
            number: '7.4',
            label: 'No. of subjects to be recruited in the site(s) stated in Q.2.3.1 above.',
        },
        p2SubjectRecruit: {
            number: '7.5',
            label: 'How will subject be identified and recruited',
            isTextArea: true,
        },
        p2NumOfExtra: {
            number: '11.3',
            label: 'Number of extra visits / admission on top of usual care',
        },
        p2OtherInvestigator: {
            number: '11.4',
            label: 'Will any of the study interventions / procedures be performed by persons other than the investigators?',
        },
        p2WhomWhere: {
            number: '11.4.1',
            label: 'If yes, by whom and where',
        },
        p3InformConsentPrincipalInv: {
            number: '13.2',
            label: 'Who will carry out the informed consent process with the subject?',
        },
        p3InformConsentOthersReason: {
            number: '13.2',
            label: 'Others',
        },
        p4ExtraHAResources: {
            number: '19.1',
            label: 'Will this study consume extra HA resources?',
        },
        p4ExtraHAResourcesDetails: {
            number: '19.1.1',
            label: 'If yes, provide details',
            isTextArea: true,
        },
        p4ExtraHAResourcesAffect: {
            number: '19.1.2',
            label: 'If extra HA resources is required, how will this affect the HA services of other patients with competing needs?',
            isTextArea: true,
        },
        p4Reimburse: {
            number: '19.2',
            label: 'Will the study site (hospital) receive reimbursement for the study?',
        },
        p4ReimburseFormat: {
            number: '19.2.1',
            label: 'If yes, state the format of reimbursement',
            isTextArea: true,
        },
        p4ReimburseReason: {
            number: '19.2.2',
            label: 'If no, state the reason(s)',
        },
        /** document upload start */
        docUpload_1: {
            number: '23',
            label: 'Subject Information Sheet and Informed Consent Form (Supplementary)',
        },
        docUpload_3: {
            number: '25',
            label: 'Written information for subject, such as recruitment advertisement, etc (Supplementary)',
        },
        docUpload_4: {
            number: '26',
            label: 'Questionnaires (Supplementary)',
        },
        docUpload_5: {
            number: '27',
            label: 'Conflict of Interest Declaration by all Investigators (Mandatory)',
        },
        docUpload_6: {
            number: '28',
            label: 'Indemnity Agreement (Mandatory for sponsored trial)',
        },
        docUpload_11: {
            number: '30',
            label: 'Other Documents – Site Information (Supplementary)',
        },
        docUpload_10: {
            number: '34',
            label: 'Signed DECLARATION AND ENDORSEMENT (Mandatory)',
        },
        /** document upload end */
        /** Declaration And Endorsement start */
        declareInv: {
            number: 'A',
            sortKey: 'A',
            popupTitle: 'Declaration by Principal Investigator and other Investigator(s)',
        },
        H: {
            number: 'B/C',
            sortKey: 'B',
            popupTitle: 'Endorsement by COS or Authorised Representative³ of HA',
        },
        U: {
            number: 'B/C',
            sortKey: 'C',
            popupTitle: 'Endorsement by Head of Department⁴ of the Universities',
        },
        C: {
            number: 'D',
            sortKey: 'D',
            popupTitle: 'Endorsement by COS(s) or Head(s) of the Collaborating Department(s) in HA or in Universities',
        },
        /** Declaration And Endorsement end */
    };
};
